import React, { useEffect, useState } from 'react'
import { Grid, Button, Stack } from '@mui/material'
import { object, func, element } from 'prop-types'
import Autores from '../../services/http/obras/Autores'
import CategoriasObras from '../../services/http/obras/CategoriasObras'
import Editoras from '../../services/http/obras/Editoras'
import SmallTextField from '../textfield/SmallTextfield'
import { BaseAutoComplete } from '../shared'

const DataForm = ({ form, handleChange, onFormChange, BackButton }) => {
  const [categorias, setCategorias] = useState([])
  const [publisher, setPublisher] = useState([])
  const [authors, setAuthors] = useState([])

  const getCategorias = async () => {
    const { data } = await CategoriasObras().show({ per_page: -1 })
    setCategorias(data.data)
  }

  const postPublisher = async () => {
    const response = await Editoras().store({ nome: form.editora })
    setPublisher(response.data.id)
  }

  const postAuthors = async formAuthors => {
    const response = await Autores().store({ autores: formAuthors })
    getIdAuthors(response.data)
  }

  const createObjectpostAuthors = () => {
    const autoresArray = form.autores.split(', ')
    const autoresArrayObject = autoresArray.map(item => {
      return { nome: item }
    })
    postAuthors(autoresArrayObject)
  }

  const getIdAuthors = array => {
    const idArray = array.map(item => item.id)
    setAuthors(idArray)
  }

  const init = () => {
    getCategorias()
  }

  useEffect(() => {
    onFormChange({
      ...form,
      editora_id: publisher,
      autores_id: authors
    })
  }, [publisher, authors])

  useEffect(() => {
    init()
  }, [])

  const categoriaChange = value => {
    onFormChange({
      ...form,
      categoria_obra_id: value.id,
      categoria_name: value.descricao
    })
  }

  return (
    <form>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <SmallTextField
            label="Autor(es)"
            onChange={({ target }) =>
              onFormChange({ ...form, autores: target.value })
            }
            value={form.autores}
            upperCase
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <SmallTextField
            label="Nº Edição"
            onChange={({ target }) =>
              onFormChange({ ...form, numero_edicao: target.value })
            }
            value={form.numero_edicao}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <SmallTextField
            label="Editora"
            onChange={({ target }) =>
              onFormChange({ ...form, editora: target.value })
            }
            value={form.editora}
            upperCase
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <BaseAutoComplete
            list={categorias}
            listLabel="descricao"
            inputProps={{ label: 'Categoria' }}
            onChange={categoriaChange}
          />
        </Grid>
      </Grid>

      <Stack
        direction="row"
        spacing={1}
        sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}
      >
        {BackButton}
        <Button
          type="button"
          variant="outlined"
          color="leitura"
          onClick={e => {
            handleChange(e, 2)
            postPublisher()
            createObjectpostAuthors()
          }}
        >
          Próximo
        </Button>
      </Stack>
    </form>
  )
}

DataForm.propTypes = {
  form: object.isRequired,
  handleChange: func,
  onFormChange: func,
  close: func,
  BackButton: element
}

export default DataForm
